<template src="./Add.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("lookups/getLookups");

  },
  computed: {
  
    analysisGroups() {
      return [
        ...this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.AnalysisGroups)]
      },
  },
  data() {
    return {
      vm: {
        analysisName: null,
        price: null,
        analysisGroupId: null
      },
    };
  },
  methods: {
    confirm() {
      this.$store
        .dispatch("analysis/add",  this.vm )
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
  
    back() {
      this.$emit("back");
    },
  },
};
</script>